module.exports = __webpack_public_path__ + "static/media/git.1bb02710.svg";